import { Route, Switch } from "react-router";
import "./App.css";
import { ROUTES } from "./config/routes";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const App = () => {
  return (
    <div className="App">
      <Switch>
        {Object.values(ROUTES).map(({ ...rest }) => (
          <Route key={rest.path} {...rest} />
        ))}
      </Switch>
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default App;
